<div scopedPalette [eduContentBookId]="eduContentBookId" [learningDomainId]="learningDomainId" [eduContentTOCId]="eduContentTOCId">
  <div>
    @switch (component) {
      @case ('assessment') {
        <div>
          <campus-assessment
            [config]="config"
            [eduContent]="eduContent"
            (close)="onCloseClicked(false)"
            (componentsLoaded)="onComponentsLoaded()"
            (playerLoadError)="onPlayerLoadError($event)"
          ></campus-assessment>
        </div>
      }
      @case ('reporting') {
        <div class="[ m-s ]">
          <div class="[ headline-large ]">{{ eduContent.name }}</div>
          <campus-learnosity-reporting [config]="config"></campus-learnosity-reporting>
        </div>
      }
      @case ('grading') {
        <div>
          <campus-grading (closed)="close($event)" [config]="config" (componentsLoaded)="onComponentsLoaded()"></campus-grading>
        </div>
      }
      @default {
        <div>
          <p>Could not find component <<{{ component }}>></p>
        </div>
      }
    }
  </div>

  <div
    data-cy="close-iframe"
    class="ui-iframe-close [ pointer ]"
    [class.disabled]="shouldPreventClose"
    [title]="shouldPreventClose ? 'Wacht tot de component is geladen...' : ''"
    (click)="onCloseClicked()"
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style="enable-background: new 0 0 24 24"
      xml:space="preserve"
    >
      <style type="text/css">
        .st0close {
          fill: none;
        }
      </style>
      <path d="M19,6.4L17.6,5L12,10.6L6.4,5L5,6.4l5.6,5.6L5,17.6L6.4,19l5.6-5.6l5.6,5.6l1.4-1.4L13.4,12L19,6.4z" />
      <path class="st0close" d="M0,0h24v24H0V0z" />
    </svg>
  </div>
</div>

@if (playerError()) {
  <dcr-dialog
    open
    prevent-close-by-escape
    type="custom"
    icon="learnosity:error"
    headline="Fout opgetreden"
    [attr.supporting-text]="playerError()"
  >
    <div slot="actions">
      <dcr-inline-button
        label="Contacteer de helpdesk"
        leading-icon="learnosity:mail"
        (click)="onPlayerErrorDialogMail()"
      ></dcr-inline-button>

      <dcr-filled-button label="Sluiten" (click)="onPlayerErrorDialogConfirm()"></dcr-filled-button>
    </div>
  </dcr-dialog>
}
